import {
    startOfWeek, endOfWeek,
    startOfMonth, endOfMonth,
    startOfQuarter, endOfQuarter,
    startOfYear, endOfYear,
    subDays, subWeeks, subMonths, subQuarters, subYears
} from 'date-fns'
import { groupBy } from 'lodash';

const today = new Date();
const thisWeekStart = startOfWeek(today);
const thisWeekEnd = endOfWeek(today);
const thisMonthStart = startOfMonth(today);
const thisMonthEnd = endOfMonth(today);
const thisQtrStart = startOfQuarter(today);
const thisQtrEnd = endOfQuarter(today);
const thisYearStart = startOfYear(today);
const thisYearEnd = endOfYear(today);
const yesterday = subDays(today, 1);


export const Today = {
    from: today,
    to: today,
    tense: 'Current',
    group: 'Day',
    label: 'Today'
};

export const ThisWeek = {
    from: thisWeekStart,
    to: thisWeekEnd,
    tense: 'Current',
    group: 'Week',
    label: 'This Week'
};

export const ThisMonth = {
    from: thisMonthStart,
    to: thisMonthEnd,
    tense: 'Current',
    group: "Month",
    label: "This Month"
};

export const ThisQuarter = {
    from: thisQtrStart,
    to: thisQtrEnd,
    tense: 'Current',
    group: 'Quarter',
    label: 'This Quarter'
};

export const ThisYear = {
    from: thisYearStart,
    to: thisYearEnd,
    tense: 'Current',
    group: 'Year',
    label: 'This Year'
};

export const Yesterday = {
    from: yesterday,
    to: yesterday,
    tense: 'Past',
    group: 'Day',
    label: 'Yesterday'
};

export const LastWeek = {
    from: subWeeks(thisWeekStart, 1),
    to: subWeeks(thisWeekEnd, 1),
    tense: 'Past',
    group: 'Week',
    label: 'Last Week'
};

export const LastMonth = {
    from: subMonths(thisMonthStart, 1),
    to: endOfMonth(subMonths(thisMonthStart, 1)),
    tense: 'Past',
    group: 'Month',
    label: 'Last Month'
};

export const LastQuarter = {
    from: subQuarters(thisQtrStart, 1),
    to: subQuarters(thisQtrEnd, 1),
    tense: 'Past',
    group: 'Quarter',
    label: 'Last Quarter'
};

export const LastYear = {
    from: subYears(thisYearStart, 1),
    to: subYears(thisYearEnd, 1),
    tense: 'Past',
    group: 'Year',
    label: 'Last Year'
};

export const ThisWeekToDate = {
    from: thisWeekStart,
    to: today,
    tense: 'Current To Date',
    group: 'Week',
    label: 'This Week To Date'
};

export const ThisMonthToDate = {
    from: thisMonthStart,
    to: today,
    tense: 'Current To Date',
    group: "Month",
    label: "This Month To Date"
};

export const ThisQuarterToDate = {
    from: thisQtrStart,
    to: today,
    tense: 'Current To Date',
    group: 'Quarter',
    label: 'This Quarter To Date'
};

export const ThisYearToDate = {
    from: thisYearStart,
    to: today,
    tense: 'Current To Date',
    group: 'Year',
    label: 'This Year To Date'
};

export const LastWeekToDate = {
    from: subWeeks(thisWeekStart, 1),
    to: today,
    tense: 'Past To Date',
    group: 'Week',
    label: 'Last Week To Date'
};

export const LastMonthToDate = {
    from: subMonths(thisMonthStart, 1),
    to: today,
    tense: 'Past To Date',
    group: 'Month',
    label: 'Last Month To Date'
};

export const LastQuarterToDate = {
    from: subQuarters(thisQtrStart, 1),
    to: today,
    tense: 'Past To Date',
    group: 'Quarter',
    label: 'Last Quarter To Date'
};

export const LastYearToDate = {
    from: subYears(thisYearStart, 1),
    to: today,
    tense: 'Past To Date',
    group: 'Year',
    label: 'Last Year To Date'
};

export const LastAndCurrentWeek = {
    from: subWeeks(thisWeekStart, 1),
    to: thisWeekEnd,
    tense: 'Past and Current',
    group: 'Week',
    label: 'Last and Current Weeks'
};

export const LastAndCurrentMonth = {
    from: subMonths(thisMonthStart, 1),
    to: thisMonthEnd,
    tense: 'Past and Current',
    group: 'Month',
    label: 'Last and Current Months'
};

export const LastAndCurrentQuarter = {
    from: subQuarters(thisQtrStart, 1),
    to: thisQtrEnd,
    tense: 'Past and Current',
    group: 'Quarter',
    label: 'Last and Current Quarters'
};

export const LastAndCurrentYear = {
    from: subYears(thisYearStart, 1),
    to: thisYearEnd,
    tense: 'Past and Current',
    group: 'Year',
    label: 'Last and Current Years'
};

export const ThisYearToLastMonthEnd = {
    from: thisYearStart,
    to: subMonths(thisMonthEnd, 1),
    tense: 'Current To Past',
    group: 'Year',
    label: 'Year To Last Month End'
};

export const ThisYearToMonthEnd = {
    from: thisYearStart,
    to: thisMonthEnd,
    tense: 'Current To Future',
    group: 'Year',
    label: 'Year To This Month End'
};

const Ranges = [
    Today,
    ThisWeek,
    ThisMonth,
    ThisQuarter,
    ThisYear,
    Yesterday,
    LastWeek,
    LastMonth,
    LastQuarter,
    LastYear,
    ThisWeekToDate,
    ThisMonthToDate,
    ThisQuarterToDate,
    ThisYearToDate,
    LastWeekToDate,
    LastMonthToDate,
    LastQuarterToDate,
    LastYearToDate,
    LastAndCurrentWeek,
    LastAndCurrentMonth,
    LastAndCurrentQuarter,
    LastAndCurrentYear,
    ThisYearToLastMonthEnd,
    ThisYearToMonthEnd,
];

export const RangesForSelect = Ranges.reduce((list, rng) => {
    let { tense } = rng;
    let group = list.find(g => g.label === tense);
    if (group) group.options.push(rng);
    else {
        list.push({
            label: tense,
            options: [rng]
        });
    };
    return list;
}, [{
    label: "Custom",
    options: [
        {
            label: 'Custom',
            from: null,
            to: null,
            tense: 'Custom',
            group: 'Custom'
        }
    ]
}]);

export const PreDefinedRanges = groupBy(Ranges, 'tense');
export default Ranges;